import React, { memo, useEffect } from 'react';
import { Dashboard, usePageEdit, pageEditActions } from '../../';
export var Admin = memo(function () {
    var _a = usePageEdit(), pageEdit = _a.pageEdit, dispatchPageEdit = _a.dispatchPageEdit;
    useEffect(function () {
        if (pageEdit.enabled)
            dispatchPageEdit({ type: pageEditActions.TOGGLE_EDIT, enabled: false });
    }, []);
    return (React.createElement(Dashboard, null));
});
